<!--
 first step - regular state
 second step - confirmation message with two buttons cancel and confirm
 third step - the last state (confirmed or canceled)
      canceled-state - confirm button
      canceled-state - confirm button
 --->

<div class="confirmation-button" [ngClass]="{
    'active-state': showConfirmation,
    'confirmed': (status === 'confirmed'),
    'canceled': (status === 'canceled')
    }">
  <div class="first-state" (click)="onClick($event)">
      <div class="text-container">
        <span class="text" [innerText]="buttonText"></span>
      </div>
  </div>
  <div class="second-state">
    <div class="text-container">
      <span class="text" [innerText]="buttonText"></span>
      <span class="sub-text" *ngIf="showConfirmation" [innerText]="confirmSubText"></span>
    </div>
  </div>

  <div class="confirm-state" (click)="confirm($event)">
    <div class="icon-container">
      <app-icon-confirm></app-icon-confirm>
    </div>
    <div class="text-container" [innerText]="buttonText"></div>
  </div>
  <div class="cancel-state" (click)="cancel($event)">
    <div class="icon-container">
      <app-icon-cancel></app-icon-cancel>
    </div>
    <div class="text-container" [innerText]="buttonText"></div>
  </div>
</div>
